import React, { useState, useRef, useEffect } from 'react';
import { FiBell } from 'react-icons/fi';
import { GiHamburgerMenu } from 'react-icons/gi';
import logoDark from '../assets/images/logo-dark.png'
import { Link, useNavigate } from 'react-router-dom';
import type { AppDispatch } from '../redux/store';
import { useDispatch } from 'react-redux';
type NavbarAppProps = {
  user: any;
  setSidebarOpen: (value: boolean) => void;
};

const NavbarApp = ({ user, setSidebarOpen }: NavbarAppProps) => {
  const [showNav, setShowNav] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const navRef = useRef<HTMLDivElement>(null);
  const userMenuRef = useRef<HTMLDivElement>(null);

  const toggleNav = () => {
    setShowNav(prev => !prev);
    setShowUserMenu(false);
  };

  const toggleUserMenu = () => {
    setShowUserMenu(prev => !prev);
    setShowNav(false);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.clear();
    dispatch({ type: 'RESET_APP' });
    navigate('/auth?mode=login');
  };

  // Close menus on outside click
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        navRef.current &&
        !navRef.current.contains(event.target as Node) &&
        userMenuRef.current &&
        !userMenuRef.current.contains(event.target as Node)
      ) {
        setShowNav(false);
        setShowUserMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="relative flex items-center justify-between px-4 py-4 bg-red-500/5 border-b border-gray-800">
      <div className="flex items-center space-x-6 w-full">
        <Link className="text-white text-xl font-bold contents" to="/dashboard">
          <img src={logoDark} className="h-10" style={{ marginTop: '-3px' }} />
        </Link>
      </div>
      <div className="flex items-center space-x-6 ml-4 relative">
        <FiBell className="text-white cursor-pointer" onClick={toggleNav} size={24} />
        <div
          className="w-8 rounded-full overflow-hidden cursor-pointer"
          onClick={toggleUserMenu}
        >
          <img
            src={user?.image ?? 'https://i.pravatar.cc/100'}
            alt={user?.name ?? 'User'}
            referrerPolicy="no-referrer"
            className="w-full h-full object-cover"
          />
        </div>
        <button onClick={() => setSidebarOpen(true)} className="md:hidden">
          <GiHamburgerMenu size={24} className="text-white" />
        </button>

        {/* User Menu */}
        {showUserMenu && (
          <div
            ref={userMenuRef}
            className="absolute top-16 right-0 bg-white text-black rounded shadow-lg py-2 w-48 z-50"
          >
            <div className="px-4 py-2 border-b">{user?.name}</div>
            <button
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
              onClick={() => navigate('/user')}
            >
              Profile
            </button>
            <button
              className="w-full text-left px-4 py-2 hover:bg-gray-100"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        )}
      </div>

      {/* Notification Menu */}
      {showNav && (
        <div
          ref={navRef}
          className="absolute top-full right-3 bg-white text-black rounded shadow-lg mt-2 py-2 w-64 z-40"
        >
          <div className="px-4 py-2 border-b font-medium">Notifications</div>
          <p className="px-4 py-2 text-sm text-gray-700">No new notifications</p>
        </div>
      )}
    </header>
  );
};

export default NavbarApp;
